import { useCompanyPageStore } from "@/store/companyPageStore";

/**
 * Hook to access intent filters from companyPageStore
 * Provides filters, setter, and reset functions
 */
export const useIntentFiltersStorage = () => {
  const intentFilters = useCompanyPageStore((state) => state.intentFilters);
  const setIntentFilters = useCompanyPageStore(
    (state) => state.setIntentFilters
  );
  const resetIntentFilters = useCompanyPageStore(
    (state) => state.resetIntentFilters
  );

  return { intentFilters, setIntentFilters, resetIntentFilters };
};
